

export const API_BASE_URL = 'https://rq5khboa9g.execute-api.us-east-2.amazonaws.com/dev';
